module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.value) ? _c('div', [_vm._l((_vm.value), function(email, i) {
    return _c('div', {
      key: i,
      staticClass: "mt-5 _clearfix"
    }, [_c('div', {
      staticClass: "col-xs-10 col-md-9 pd-0"
    }, [_c('div', {}, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.value[i]),
        expression: "value[i]"
      }],
      staticClass: "form-control form__text form__email",
      attrs: {
        "type": "text",
        "name": "title",
        "placeholder": "อีเมล",
        "id": "ecard-mail-01"
      },
      domProps: {
        "value": (_vm.value[i])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.value, i, $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 col-md-3"
    }, [_c('a', {
      staticClass: "-remove",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeEmail(i)
        }
      }
    }, [_vm._v("ลบ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "_clearboth mt-15"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("รูปแบบอีเมลไม่ถูกต้อง")]), _vm._v(" "), _c('a', {
    staticClass: "-add_plus",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addEmail.apply(null, arguments)
      }
    }
  }, [_vm._v("เพิ่มอีเมล")])])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-704813a7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SendEmailForm.vue
// module id = 1183
// module chunks = 0